/** Has average is on, and the field is empty or outside 0–300. */
export const teamEditAverageErrors = (bowlers = []) => {
  const errors = {};
  bowlers.forEach((bowler, index) => {
    if (bowler?.pendingReplacement || bowler?.isNew || bowler?.isVerified) {
      return;
    }
    if (bowler?.hasAverage === false) return;
    const raw = bowler?.average;
    if (raw === "" || raw == null || String(raw).trim() === "") {
      errors[index] = "Enter an average, or turn off Has average.";
      return;
    }
    const average = Number(raw);
    if (Number.isNaN(average) || average < 0 || average > 300) {
      errors[index] = "Average must be between 0 and 300";
    }
  });
  return errors;
};

export const teamEditRpcMessage = (error, fallback) => {
  const raw = String(error?.message || "");
  const message = raw
    .replace(/^.*ERROR:\s*/i, "")
    .replace(/\s+Where:[\s\S]*$/i, "")
    .replace(/\s+CONTEXT:[\s\S]*$/i, "")
    .trim()
    .split("\n")[0];
  if (/average_required_when_has_average/i.test(raw)) {
    return "This bowler needs an average, or mark them as scratch.";
  }
  if (
    /unverify|already on this team|not found|permission|full|not available|same primary|insufficient|a name is required|a squad is required|a bowler is required/i.test(
      message
    )
  ) {
    return message;
  }
  return fallback;
};

/** Change bowler does not collect an average. Org people with no tournament average are scratch. */
export const replaceBowlerAveragePayload = (selectedBowler) => {
  if (selectedBowler?.hasAverage === false) {
    return { average: null, hasAverage: false };
  }
  const raw = selectedBowler?.average;
  if (raw === "" || raw == null) {
    return { average: null, hasAverage: false };
  }
  const average = Number(raw);
  if (Number.isNaN(average)) {
    return { average: null, hasAverage: false };
  }
  return { average, hasAverage: true };
};
